var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("csIcon iconfont icon" + _vm.name),style:(("font-size: " + _vm.computedSize + "; color: " + _vm.color)),on:{"click":_vm.clickIcon}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-967cba6a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/src/icon.vue
// module id = 104
// module chunks = 0 9 37